import React from 'react';
import { Link } from 'react-router-dom';

const Landing: React.FC = () => {
  return (
    <>
      <style>{`
        .lp *, .lp *::before, .lp *::after { box-sizing: border-box; margin: 0; padding: 0; }
        .lp {
          --bg: #f8f7f4; --surface: #ffffff; --surface2: #f0ede7;
          --border: #e2ddd5; --text: #1a1714; --muted: #6b6560;
          --accent: #2a6ef5; --teal: #0ea882; --gold: #e8a020; --navy: #0f1f4a;
          --nav-h: 68px;
          font-family: system-ui, -apple-system, 'Segoe UI', sans-serif;
          background: var(--bg); color: var(--text);
          font-size: 15px; line-height: 1.65;
          -webkit-font-smoothing: antialiased;
        }

        /* NAV */
        .lp-nav {
          position: fixed; top: 0; left: 0; right: 0; z-index: 100;
          height: var(--nav-h);
          background: rgba(248,247,244,0.94);
          border-bottom: 1px solid var(--border);
          display: flex; align-items: center; padding: 0 5%; gap: 40px;
        }
        .lp-logo {
          font-family: Georgia, serif; font-size: 22px; font-weight: bold;
          color: var(--navy); text-decoration: none; flex-shrink: 0;
        }
        .lp-logo span { color: var(--accent); }
        .lp-nav-links { display: flex; gap: 28px; list-style: none; flex: 1; }
        .lp-nav-links a { text-decoration: none; color: var(--muted); font-size: 13.5px; font-weight: 500; }
        .lp-nav-links a:hover { color: var(--text); }
        .lp-nav-actions { display: flex; gap: 10px; align-items: center; margin-left: auto; }

        /* BUTTONS */
        .lp-btn {
          display: inline-flex; align-items: center; gap: 7px;
          padding: 9px 20px; border-radius: 8px; font-size: 13.5px;
          font-weight: 600; cursor: pointer; text-decoration: none;
          border: none; font-family: inherit; white-space: nowrap;
        }
        .lp-btn-ghost { background: transparent; color: var(--text); border: 1.5px solid var(--border); }
        .lp-btn-ghost:hover { border-color: var(--accent); color: var(--accent); }
        .lp-btn-primary { background: var(--navy); color: #fff; }
        .lp-btn-primary:hover { background: #0d4fcf; }
        .lp-btn-accent { background: var(--accent); color: #fff; }
        .lp-btn-accent:hover { background: #0d4fcf; }
        .lp-btn-ghost-light { background: transparent; color: #fff; border: 1.5px solid rgba(255,255,255,.3); }
        .lp-btn-xl { padding: 16px 36px; font-size: 16px; border-radius: 11px; }
        .lp-btn-block { display: flex; justify-content: center; width: 100%; padding: 13px 0; font-size: 15px; }

        /* LAYOUT */
        .lp-section { padding: 100px 5%; }
        .lp-container { max-width: 1140px; margin: 0 auto; }
        .lp-text-center { text-align: center; }

        /* HERO */
        .lp-hero {
          padding-top: calc(var(--nav-h) + 80px);
          padding-bottom: 80px; padding-left: 5%; padding-right: 5%;
          background: var(--bg); overflow: hidden;
        }
        .lp-hero-grid {
          max-width: 1140px; margin: 0 auto;
          display: grid; grid-template-columns: 1fr 1fr; gap: 60px; align-items: center;
        }
        .lp-hero-badge {
          display: inline-flex; align-items: center; gap: 7px;
          background: #e8f0fe; color: var(--accent); border-radius: 20px;
          padding: 5px 14px; font-size: 12.5px; font-weight: 600;
          letter-spacing: .4px; text-transform: uppercase; margin-bottom: 22px;
        }
        .lp-hero-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--teal); display: inline-block; }
        .lp-h1 {
          font-family: Georgia, serif; font-size: clamp(38px, 4.5vw, 58px);
          line-height: 1.12; letter-spacing: -1px; color: var(--navy); margin-bottom: 22px;
        }
        .lp-h1 em { font-style: italic; color: var(--accent); }
        .lp-hero-sub { font-size: 17px; color: var(--muted); max-width: 480px; line-height: 1.7; margin-bottom: 36px; }
        .lp-hero-actions { display: flex; gap: 12px; flex-wrap: wrap; }
        .lp-hero-stats {
          display: flex; gap: 36px; margin-top: 48px;
          padding-top: 36px; border-top: 1px solid var(--border);
        }
        .lp-stat-n { font-family: Georgia, serif; font-size: 28px; color: var(--navy); font-weight: bold; }
        .lp-stat-l { font-size: 12.5px; color: var(--muted); font-weight: 500; }

        /* MOCKUP */
        .lp-mockup-window {
          background: var(--surface); border-radius: 14px; border: 1px solid var(--border); overflow: hidden;
          box-shadow: 0 24px 60px rgba(10,30,80,.12), 0 4px 16px rgba(0,0,0,.06);
        }
        .lp-mockup-titlebar {
          background: #f0ede7; padding: 10px 16px;
          display: flex; align-items: center; gap: 7px; border-bottom: 1px solid var(--border);
        }
        .lp-dot-r { width: 11px; height: 11px; border-radius: 50%; background: #f25c38; display: inline-block; }
        .lp-dot-y { width: 11px; height: 11px; border-radius: 50%; background: #e8a020; display: inline-block; }
        .lp-dot-g { width: 11px; height: 11px; border-radius: 50%; background: #2bc96e; display: inline-block; }
        .lp-mockup-body { display: grid; grid-template-columns: 170px 1fr; min-height: 340px; }
        .lp-mockup-sidebar {
          background: var(--navy); padding: 20px 14px;
          display: flex; flex-direction: column; gap: 4px;
        }
        .lp-sidebar-logo { font-family: Georgia, serif; color: #fff; font-size: 16px; font-weight: bold; margin-bottom: 20px; padding: 0 4px; }
        .lp-sidebar-item { display: flex; align-items: center; gap: 9px; padding: 8px 10px; border-radius: 7px; color: rgba(255,255,255,.6); font-size: 12.5px; font-weight: 500; }
        .lp-sidebar-item.active { background: rgba(42,110,245,.35); color: #fff; }
        .lp-mockup-main { padding: 20px; background: var(--surface); }
        .lp-mock-title { font-size: 13px; font-weight: 700; margin-bottom: 14px; color: var(--navy); }
        .lp-cal-strip { display: flex; gap: 5px; margin-bottom: 14px; }
        .lp-cal-day { flex: 1; text-align: center; padding: 8px 4px; border-radius: 7px; font-size: 11px; font-weight: 600; color: var(--muted); background: var(--surface2); }
        .lp-cal-day.today { background: var(--accent); color: #fff; }
        .lp-cal-num { font-size: 14px; display: block; }
        .lp-appt { display: flex; align-items: center; gap: 8px; padding: 8px 10px; border-radius: 7px; margin-bottom: 5px; font-size: 11.5px; }
        .lp-appt-bar { width: 3px; height: 28px; border-radius: 2px; flex-shrink: 0; }
        .lp-appt-name { font-weight: 600; color: var(--text); }
        .lp-appt-type { color: var(--muted); font-size: 11px; }
        .lp-appt-time { margin-left: auto; color: var(--muted); font-size: 11px; }
        .lp-appt-blue { background: #eff4ff; }
        .lp-appt-teal { background: #edfaf4; }
        .lp-appt-gold { background: #fef8ec; }
        .lp-mock-stats { display: grid; grid-template-columns: repeat(3,1fr); gap: 8px; margin-top: 12px; }
        .lp-mock-stat { background: var(--surface2); border-radius: 8px; padding: 10px; text-align: center; }
        .lp-mock-stat-val { font-size: 18px; font-weight: 700; color: var(--navy); }
        .lp-mock-stat-lbl { font-size: 10.5px; color: var(--muted); }

        /* LOGOS BAND */
        .lp-logos { padding: 40px 5%; border-top: 1px solid var(--border); border-bottom: 1px solid var(--border); background: var(--surface); }
        .lp-logos-inner { max-width: 1140px; margin: 0 auto; display: flex; align-items: center; gap: 16px; flex-wrap: wrap; }
        .lp-logos-label { font-size: 12.5px; color: var(--muted); font-weight: 500; white-space: nowrap; margin-right: 10px; }
        .lp-logo-pill { background: var(--surface2); border: 1px solid var(--border); border-radius: 8px; padding: 7px 18px; font-size: 13px; font-weight: 700; color: var(--muted); }

        /* FEATURES */
        .lp-features-bg { background: var(--surface); }
        .lp-section-label { display: inline-block; font-size: 12px; font-weight: 700; letter-spacing: 1.5px; text-transform: uppercase; color: var(--accent); margin-bottom: 12px; }
        .lp-h2 { font-family: Georgia, serif; font-size: clamp(28px, 3.5vw, 44px); color: var(--navy); line-height: 1.18; letter-spacing: -.5px; font-weight: bold; }
        .lp-h2 em { font-style: italic; color: var(--accent); }
        .lp-section-sub { font-size: 16px; color: var(--muted); margin-top: 12px; max-width: 540px; }
        .lp-section-header { margin-bottom: 60px; }
        .lp-features-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 28px; margin-top: 50px; }
        .lp-feature-card { background: var(--bg); border: 1px solid var(--border); border-radius: 14px; padding: 28px; }
        .lp-feature-icon { width: 44px; height: 44px; border-radius: 10px; display: flex; align-items: center; justify-content: center; margin-bottom: 18px; font-size: 20px; }
        .lp-fi-blue { background: #e8f0fe; } .lp-fi-teal { background: #e6faf4; } .lp-fi-gold { background: #fef6e4; }
        .lp-fi-coral { background: #fef0ed; } .lp-fi-purple { background: #f0ecff; } .lp-fi-navy { background: #e8ecf5; }
        .lp-feature-card h3 { font-size: 16px; font-weight: 700; color: var(--navy); margin-bottom: 8px; }
        .lp-feature-card p { font-size: 14px; color: var(--muted); line-height: 1.65; }
        .lp-feature-tag { display: inline-block; margin-top: 14px; font-size: 11.5px; font-weight: 600; color: var(--accent); background: #e8f0fe; border-radius: 5px; padding: 3px 9px; }

        /* PREVIEW */
        .lp-preview-bg { background: var(--navy); overflow: hidden; }
        .lp-preview-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
        .lp-preview-text .lp-section-label { color: #7aadff; }
        .lp-preview-text .lp-h2 { color: #fff; }
        .lp-preview-text .lp-h2 em { color: #7aadff; }
        .lp-preview-text .lp-section-sub { color: rgba(255,255,255,.65); }
        .lp-preview-feature { display: flex; align-items: flex-start; gap: 14px; margin-top: 28px; }
        .lp-pf-icon { width: 38px; height: 38px; border-radius: 9px; background: rgba(255,255,255,.1); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 17px; }
        .lp-pf-title { font-weight: 700; color: #fff; font-size: 14.5px; margin-bottom: 3px; }
        .lp-pf-desc { font-size: 13.5px; color: rgba(255,255,255,.6); line-height: 1.6; }
        .lp-preview-screens { display: flex; flex-direction: column; gap: 12px; }
        .lp-screen-card { background: var(--surface); border-radius: 12px; padding: 18px 20px; border: 1px solid var(--border); box-shadow: 0 8px 24px rgba(0,0,0,.2); }
        .lp-screen-card:nth-child(2) { margin-left: 32px; }
        .lp-screen-card:nth-child(3) { margin-left: 64px; }
        .lp-sc-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
        .lp-sc-title { font-size: 12px; font-weight: 700; color: var(--navy); }
        .lp-sc-badge { font-size: 10.5px; font-weight: 600; padding: 2px 9px; border-radius: 20px; }
        .lp-badge-green { background: #e6faf4; color: var(--teal); }
        .lp-badge-blue { background: #e8f0fe; color: var(--accent); }
        .lp-badge-gold { background: #fef6e4; color: var(--gold); }
        .lp-sc-row { display: flex; align-items: center; gap: 10px; padding: 6px 0; border-bottom: 1px solid var(--border); font-size: 12px; }
        .lp-sc-row:last-child { border-bottom: none; }
        .lp-sc-dot { width: 7px; height: 7px; border-radius: 50%; flex-shrink: 0; }
        .lp-sc-name { font-weight: 600; color: var(--text); flex: 1; }
        .lp-sc-val { color: var(--muted); }
        .lp-progress-row { margin-bottom: 10px; }
        .lp-progress-label { display: flex; justify-content: space-between; font-size: 11.5px; color: var(--muted); margin-bottom: 5px; font-weight: 500; }
        .lp-progress-track { height: 6px; background: var(--surface2); border-radius: 99px; overflow: hidden; }
        .lp-progress-fill { height: 100%; border-radius: 99px; }

        /* PRICING */
        .lp-pricing-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; margin-top: 52px; }
        .lp-plan-card { background: var(--surface); border: 1.5px solid var(--border); border-radius: 16px; padding: 32px; position: relative; }
        .lp-plan-card.popular { border-color: var(--accent); box-shadow: 0 0 0 4px rgba(42,110,245,.1); }
        .lp-popular-badge { position: absolute; top: -13px; left: 50%; transform: translateX(-50%); background: var(--accent); color: #fff; font-size: 11px; font-weight: 700; letter-spacing: .8px; text-transform: uppercase; padding: 4px 16px; border-radius: 20px; }
        .lp-plan-name { font-size: 13px; font-weight: 700; color: var(--muted); text-transform: uppercase; letter-spacing: .8px; margin-bottom: 8px; }
        .lp-plan-price { font-family: Georgia, serif; font-size: 46px; color: var(--navy); line-height: 1; margin-bottom: 4px; font-weight: bold; }
        .lp-plan-price sup { font-size: 22px; vertical-align: top; margin-top: 8px; display: inline-block; }
        .lp-plan-period { font-size: 13px; color: var(--muted); margin-bottom: 24px; }
        .lp-plan-divider { border: none; border-top: 1px solid var(--border); margin: 20px 0; }
        .lp-plan-features { list-style: none; display: flex; flex-direction: column; gap: 11px; margin-bottom: 28px; }
        .lp-plan-features li { display: flex; align-items: center; gap: 9px; font-size: 14px; color: var(--text); }
        .lp-check { color: var(--teal); font-size: 15px; flex-shrink: 0; }
        .lp-cross { color: #ccc; font-size: 13px; flex-shrink: 0; }
        .lp-plan-features li.disabled { color: var(--muted); }
        .lp-plan-desc { font-size: 13.5px; color: var(--muted); line-height: 1.6; margin-bottom: 20px; }

        /* LOGIN SECTION */
        .lp-login-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center; }
        .lp-trust-item { display: flex; align-items: center; gap: 11px; margin-bottom: 16px; font-size: 14px; color: var(--text); }
        .lp-trust-icon { width: 36px; height: 36px; border-radius: 8px; background: var(--bg); border: 1px solid var(--border); display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 16px; }
        .lp-login-form { background: var(--bg); border: 1px solid var(--border); border-radius: 16px; padding: 36px; }
        .lp-form-title { font-family: Georgia, serif; font-size: 24px; color: var(--navy); margin-bottom: 6px; font-weight: bold; }
        .lp-form-sub { font-size: 14px; color: var(--muted); margin-bottom: 28px; }
        .lp-form-group { margin-bottom: 18px; }
        .lp-label { display: block; font-size: 13px; font-weight: 600; color: var(--text); margin-bottom: 6px; }
        .lp-input-mock { width: 100%; padding: 11px 14px; border: 1.5px solid var(--border); border-radius: 8px; background: var(--surface); color: var(--muted); font-family: inherit; font-size: 14px; display: block; line-height: 1.8; }
        .lp-form-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 18px; }
        .lp-remember { display: flex; align-items: center; gap: 7px; font-size: 13px; color: var(--muted); }
        .lp-forgot { font-size: 13px; color: var(--accent); text-decoration: none; }
        .lp-form-divider { display: flex; align-items: center; gap: 12px; margin: 20px 0; color: var(--muted); font-size: 13px; }
        .lp-form-divider::before, .lp-form-divider::after { content: ''; flex: 1; height: 1px; background: var(--border); }
        .lp-signup { text-align: center; font-size: 13.5px; color: var(--muted); margin-top: 18px; }
        .lp-signup a { color: var(--accent); font-weight: 600; text-decoration: none; }

        /* CTA */
        .lp-cta-bg { background: var(--navy); text-align: center; }
        .lp-cta-bg .lp-h2 { color: #fff; max-width: 640px; margin: 0 auto 16px; }
        .lp-cta-bg .lp-h2 em { color: #7aadff; }
        .lp-cta-sub { color: rgba(255,255,255,.65); font-size: 16px; max-width: 480px; margin: 0 auto 36px; }
        .lp-cta-actions { display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; }

        /* FOOTER */
        .lp-footer { background: #0b1630; color: rgba(255,255,255,.5); padding: 60px 5% 30px; }
        .lp-footer-grid { max-width: 1140px; margin: 0 auto; display: grid; grid-template-columns: 2fr 1fr 1fr 1fr; gap: 48px; margin-bottom: 52px; }
        .lp-footer-logo { font-family: Georgia, serif; font-size: 20px; color: #fff; font-weight: bold; margin-bottom: 12px; display: block; text-decoration: none; }
        .lp-footer-logo span { color: #7aadff; }
        .lp-footer-desc { font-size: 13.5px; line-height: 1.7; }
        .lp-footer-col h4 { color: #fff; font-size: 13px; font-weight: 700; margin-bottom: 16px; letter-spacing: .4px; }
        .lp-footer-col a { display: block; color: rgba(255,255,255,.5); text-decoration: none; font-size: 13.5px; margin-bottom: 10px; }
        .lp-footer-col a:hover { color: #fff; }
        .lp-footer-bottom { max-width: 1140px; margin: 0 auto; display: flex; justify-content: space-between; align-items: center; padding-top: 28px; border-top: 1px solid rgba(255,255,255,.1); font-size: 12.5px; }

        @media (max-width: 900px) {
          .lp-hero-grid, .lp-preview-grid, .lp-login-grid { grid-template-columns: 1fr; }
          .lp-features-grid, .lp-pricing-grid { grid-template-columns: 1fr; }
          .lp-hero-mockup { display: none; }
          .lp-footer-grid { grid-template-columns: 1fr 1fr; }
          .lp-preview-screens { display: none; }
          .lp-nav-links { display: none; }
        }
      `}</style>

      <div className="lp">
        {/* NAV */}
        <nav className="lp-nav">
          <a href="#" className="lp-logo">Plann<span>itas</span></a>
          <ul className="lp-nav-links">
            <li><a href="#features">Funcionalidades</a></li>
            <li><a href="#preview">La App</a></li>
            <li><a href="#pricing">Precios</a></li>
            <li><a href="#login-section">Acceder</a></li>
          </ul>
          <div className="lp-nav-actions">
            <Link to="/login" className="lp-btn lp-btn-ghost">Iniciar sesión</Link>
            <a href="#pricing" className="lp-btn lp-btn-primary">Empezar gratis</a>
          </div>
        </nav>

        {/* HERO */}
        <section className="lp-hero">
          <div className="lp-hero-grid">
            <div>
              <div className="lp-hero-badge"><span className="lp-hero-dot" />&nbsp;Gestión dental moderna</div>
              <h1 className="lp-h1">Tu clínica dental,<br /><em>perfectamente</em><br />organizada.</h1>
              <p className="lp-hero-sub">Plannitas centraliza citas, pacientes e intervenciones en una única plataforma intuitiva. Dedica más tiempo a tus pacientes y menos a la administración.</p>
              <div className="lp-hero-actions">
                <a href="#pricing" className="lp-btn lp-btn-accent lp-btn-xl">Prueba gratis 14 días</a>
                <a href="#preview" className="lp-btn lp-btn-ghost lp-btn-xl">Ver demo →</a>
              </div>
              <div className="lp-hero-stats">
                <div><div className="lp-stat-n">4.9 ★</div><div className="lp-stat-l">Valoración media</div></div>
                <div><div className="lp-stat-n">+500</div><div className="lp-stat-l">Clínicas activas</div></div>
                <div><div className="lp-stat-n">98%</div><div className="lp-stat-l">Tasa de retención</div></div>
              </div>
            </div>

            <div className="lp-hero-mockup">
              <div className="lp-mockup-window">
                <div className="lp-mockup-titlebar">
                  <span className="lp-dot-r" /><span className="lp-dot-y" /><span className="lp-dot-g" />
                </div>
                <div className="lp-mockup-body">
                  <div className="lp-mockup-sidebar">
                    <div className="lp-sidebar-logo">Plannitas</div>
                    <div className="lp-sidebar-item active">▌ Dashboard</div>
                    <div className="lp-sidebar-item">📅 Calendario</div>
                    <div className="lp-sidebar-item">👤 Pacientes</div>
                    <div className="lp-sidebar-item">★ Tratamientos</div>
                    <div className="lp-sidebar-item">📈 Estadísticas</div>
                  </div>
                  <div className="lp-mockup-main">
                    <div className="lp-mock-title">Citas de hoy — Lunes 14 julio</div>
                    <div className="lp-cal-strip">
                      <div className="lp-cal-day"><span className="lp-cal-num">12</span>Sáb</div>
                      <div className="lp-cal-day"><span className="lp-cal-num">13</span>Dom</div>
                      <div className="lp-cal-day today"><span className="lp-cal-num">14</span>Lun</div>
                      <div className="lp-cal-day"><span className="lp-cal-num">15</span>Mar</div>
                      <div className="lp-cal-day"><span className="lp-cal-num">16</span>Mié</div>
                    </div>
                    <div className="lp-appt lp-appt-blue">
                      <div className="lp-appt-bar" style={{ background: '#2a6ef5' }} />
                      <div><div className="lp-appt-name">María García</div><div className="lp-appt-type">Revisión anual</div></div>
                      <div className="lp-appt-time">09:00</div>
                    </div>
                    <div className="lp-appt lp-appt-teal">
                      <div className="lp-appt-bar" style={{ background: '#0ea882' }} />
                      <div><div className="lp-appt-name">Carlos Ruiz</div><div className="lp-appt-type">Ortodoncia</div></div>
                      <div className="lp-appt-time">10:30</div>
                    </div>
                    <div className="lp-appt lp-appt-gold">
                      <div className="lp-appt-bar" style={{ background: '#e8a020' }} />
                      <div><div className="lp-appt-name">Laura Martínez</div><div className="lp-appt-type">Implante</div></div>
                      <div className="lp-appt-time">12:00</div>
                    </div>
                    <div className="lp-mock-stats">
                      <div className="lp-mock-stat"><div className="lp-mock-stat-val">8</div><div className="lp-mock-stat-lbl">Citas hoy</div></div>
                      <div className="lp-mock-stat"><div className="lp-mock-stat-val">247</div><div className="lp-mock-stat-lbl">Pacientes</div></div>
                      <div className="lp-mock-stat"><div className="lp-mock-stat-val">96%</div><div className="lp-mock-stat-lbl">Asistencia</div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* LOGOS */}
        <div className="lp-logos">
          <div className="lp-logos-inner">
            <span className="lp-logos-label">Integrado con</span>
            <span className="lp-logo-pill">Supabase</span>
            <span className="lp-logo-pill">Stripe</span>
            <span className="lp-logo-pill">WhatsApp</span>
            <span className="lp-logo-pill">Google Calendar</span>
            <span className="lp-logo-pill">SendGrid</span>
            <span className="lp-logo-pill">Twilio</span>
          </div>
        </div>

        {/* FEATURES */}
        <section id="features" className="lp-section lp-features-bg">
          <div className="lp-container">
            <div className="lp-section-header">
              <div className="lp-section-label">Funcionalidades</div>
              <h2 className="lp-h2">Todo lo que tu clínica<br /><em>necesita</em>, en un solo lugar</h2>
              <p className="lp-section-sub">Desde la primera cita hasta el historial completo del paciente. Plannitas cubre cada etapa del flujo de trabajo dental.</p>
            </div>
            <div className="lp-features-grid">
              {[
                { icon: '📅', bg: 'lp-fi-blue', title: 'Calendario Interactivo', desc: 'Gestiona citas con drag & drop al estilo Google Calendar. Vistas de mes, semana y día. Colores por estado y dentista.', tag: 'Drag & drop' },
                { icon: '👥', bg: 'lp-fi-teal', title: 'Gestión de Pacientes', desc: 'Ficha completa con historial médico, dental, alergias, medicamentos y contacto de emergencia. Búsqueda instantánea.', tag: 'Historial completo' },
                { icon: '🦷', bg: 'lp-fi-gold', title: 'Intervenciones Detalladas', desc: 'Registra tratamientos por diente, superficie y cuadrante. Materiales, costes, duración y seguimiento de complicaciones.', tag: 'Odontograma' },
                { icon: '📊', bg: 'lp-fi-coral', title: 'Dashboard en Tiempo Real', desc: 'Resumen diario de citas, estadísticas de ingresos, intervenciones recientes y acciones rápidas desde un panel central.', tag: 'Métricas live' },
                { icon: '🔔', bg: 'lp-fi-purple', title: 'Notificaciones Automáticas', desc: 'Recordatorios de cita por SMS y email. Alertas de seguimiento y notificaciones internas para el equipo.', tag: 'SMS & Email' },
                { icon: '🤖', bg: 'lp-fi-navy', title: 'Asistente IA', desc: 'Agente inteligente que analiza historiales, sugiere tratamientos y responde preguntas sobre pacientes en lenguaje natural.', tag: 'Powered by AI' },
              ].map((f) => (
                <div key={f.title} className="lp-feature-card">
                  <div className={`lp-feature-icon ${f.bg}`}>{f.icon}</div>
                  <h3>{f.title}</h3>
                  <p>{f.desc}</p>
                  <span className="lp-feature-tag">{f.tag}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* PREVIEW */}
        <section id="preview" className="lp-section lp-preview-bg">
          <div className="lp-container">
            <div className="lp-preview-grid">
              <div className="lp-preview-text">
                <div className="lp-section-label">La App en acción</div>
                <h2 className="lp-h2">Diseñada para <em>dentistas</em>,<br />no para técnicos</h2>
                <p className="lp-section-sub">Interfaz limpia y flujos de trabajo pensados para el día a día de una clínica. Sin curvas de aprendizaje.</p>
                {[
                  { icon: '📋', title: 'Historial médico unificado', desc: 'Accede a toda la información del paciente desde la cita: alergias, medicamentos, tratamientos anteriores y notas clínicas.' },
                  { icon: '💊', title: 'Control de inventario', desc: 'Gestiona materiales, proveedores y pedidos. Alertas automáticas de stock mínimo para nunca quedarte sin lo esencial.' },
                  { icon: '💰', title: 'Gestión de cobros', desc: 'Genera presupuestos, registra pagos y controla el estado financiero de cada tratamiento con un solo clic.' },
                ].map((f) => (
                  <div key={f.title} className="lp-preview-feature">
                    <div className="lp-pf-icon">{f.icon}</div>
                    <div><div className="lp-pf-title">{f.title}</div><div className="lp-pf-desc">{f.desc}</div></div>
                  </div>
                ))}
              </div>
              <div className="lp-preview-screens">
                <div className="lp-screen-card">
                  <div className="lp-sc-header"><div className="lp-sc-title">📋 Últimos pacientes</div><div className="lp-sc-badge lp-badge-blue">12 nuevos este mes</div></div>
                  {[['#0ea882','Ana Fernández','Revisión · hoy'],['#2a6ef5','Pedro Morales','Implante · ayer'],['#e8a020','Sofía López','Ortodoncia · lun']].map(([c,n,v])=>(
                    <div key={n} className="lp-sc-row"><div className="lp-sc-dot" style={{background:c}}/><div className="lp-sc-name">{n}</div><div className="lp-sc-val">{v}</div></div>
                  ))}
                </div>
                <div className="lp-screen-card">
                  <div className="lp-sc-header"><div className="lp-sc-title">📊 Intervenciones del mes</div><div className="lp-sc-badge lp-badge-green">+18% vs anterior</div></div>
                  {[['Implantes','38','75%','#2a6ef5'],['Ortodoncias','24','50%','#0ea882'],['Limpiezas','61','90%','#e8a020']].map(([l,v,w,c])=>(
                    <div key={l} className="lp-progress-row">
                      <div className="lp-progress-label"><span>{l}</span><span>{v}</span></div>
                      <div className="lp-progress-track"><div className="lp-progress-fill" style={{width:w,background:c}}/></div>
                    </div>
                  ))}
                </div>
                <div className="lp-screen-card">
                  <div className="lp-sc-header"><div className="lp-sc-title">💰 Facturación — Julio 2025</div><div className="lp-sc-badge lp-badge-gold">€14.280 acumulado</div></div>
                  <div className="lp-sc-row"><div className="lp-sc-dot" style={{background:'#0ea882'}}/><div className="lp-sc-name">Cobrado</div><div className="lp-sc-val">€11.940</div></div>
                  <div className="lp-sc-row"><div className="lp-sc-dot" style={{background:'#e8a020'}}/><div className="lp-sc-name">Pendiente</div><div className="lp-sc-val">€2.340</div></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section id="pricing" className="lp-section" style={{background:'var(--bg)' as any}}>
          <div className="lp-container lp-text-center">
            <div className="lp-section-label">Precios</div>
            <h2 className="lp-h2">Sin sorpresas. Sin letra pequeña.</h2>
            <p className="lp-section-sub" style={{margin:'12px auto 0',textAlign:'center'}}>Planes pensados para clínicas de todos los tamaños. Cambia o cancela cuando quieras.</p>
          </div>
          <div className="lp-container">
            <div className="lp-pricing-grid">
              <div className="lp-plan-card">
                <div className="lp-plan-name">Básico</div>
                <div className="lp-plan-price"><sup>€</sup>0</div>
                <div className="lp-plan-period">gratis para siempre</div>
                <p className="lp-plan-desc">Para clínicas pequeñas que están empezando. Sin tarjeta de crédito.</p>
                <hr className="lp-plan-divider" />
                <ul className="lp-plan-features">
                  <li><span className="lp-check">✓</span> Hasta 50 pacientes</li>
                  <li><span className="lp-check">✓</span> Calendario básico</li>
                  <li><span className="lp-check">✓</span> 1 dentista</li>
                  <li><span className="lp-check">✓</span> Dashboard esencial</li>
                  <li className="disabled"><span className="lp-cross">✕</span> Asistente IA</li>
                  <li className="disabled"><span className="lp-cross">✕</span> Notificaciones SMS</li>
                  <li className="disabled"><span className="lp-cross">✕</span> Informes avanzados</li>
                </ul>
                <Link to="/login" className="lp-btn lp-btn-ghost lp-btn-block">Empezar gratis</Link>
              </div>

              <div className="lp-plan-card popular">
                <div className="lp-popular-badge">Más popular</div>
                <div className="lp-plan-name">Profesional</div>
                <div className="lp-plan-price"><sup>€</sup>49</div>
                <div className="lp-plan-period">por mes · por clínica</div>
                <p className="lp-plan-desc">El plan completo para clínicas en crecimiento con todo el equipo.</p>
                <hr className="lp-plan-divider" />
                <ul className="lp-plan-features">
                  <li><span className="lp-check">✓</span> Pacientes ilimitados</li>
                  <li><span className="lp-check">✓</span> Calendario drag &amp; drop</li>
                  <li><span className="lp-check">✓</span> Hasta 5 dentistas</li>
                  <li><span className="lp-check">✓</span> Asistente IA incluido</li>
                  <li><span className="lp-check">✓</span> Notificaciones SMS &amp; Email</li>
                  <li><span className="lp-check">✓</span> Informes y estadísticas</li>
                  <li className="disabled"><span className="lp-cross">✕</span> Multi-clínica</li>
                </ul>
                <Link to="/login" className="lp-btn lp-btn-accent lp-btn-block">Prueba gratis 14 días</Link>
              </div>

              <div className="lp-plan-card">
                <div className="lp-plan-name">Clínica</div>
                <div className="lp-plan-price"><sup>€</sup>99</div>
                <div className="lp-plan-period">por mes · multi-sede</div>
                <p className="lp-plan-desc">Para grupos de clínicas o centros con múltiples sedes y equipos grandes.</p>
                <hr className="lp-plan-divider" />
                <ul className="lp-plan-features">
                  <li><span className="lp-check">✓</span> Todo lo de Profesional</li>
                  <li><span className="lp-check">✓</span> Dentistas ilimitados</li>
                  <li><span className="lp-check">✓</span> Gestión multi-sede</li>
                  <li><span className="lp-check">✓</span> API &amp; integraciones</li>
                  <li><span className="lp-check">✓</span> Onboarding dedicado</li>
                  <li><span className="lp-check">✓</span> Soporte prioritario 24/7</li>
                  <li><span className="lp-check">✓</span> SLA garantizado</li>
                </ul>
                <Link to="/login" className="lp-btn lp-btn-primary lp-btn-block">Contactar ventas</Link>
              </div>
            </div>
          </div>
        </section>

        {/* LOGIN SECTION */}
        <section id="login-section" className="lp-section" style={{background:'var(--surface)' as any}}>
          <div className="lp-container">
            <div className="lp-login-grid">
              <div>
                <div className="lp-section-label">Acceso seguro</div>
                <h2 className="lp-h2">Tu clínica, siempre<br /><em>a mano</em></h2>
                <p className="lp-section-sub" style={{marginBottom:28}}>Accede desde cualquier dispositivo. Tus datos están cifrados y seguros en todo momento.</p>
                {[
                  ['🔒', 'Cifrado SSL en todas las comunicaciones'],
                  ['☁️', 'Backup automático diario en la nube'],
                  ['⚡', 'Disponibilidad del 99.9% garantizada'],
                  ['🇪🇺', 'Datos almacenados en la Unión Europea · RGPD'],
                ].map(([icon, text]) => (
                  <div key={text} className="lp-trust-item">
                    <div className="lp-trust-icon">{icon}</div>
                    <div>{text}</div>
                  </div>
                ))}
              </div>
              <div className="lp-login-form">
                <div className="lp-form-title">Bienvenido de nuevo</div>
                <div className="lp-form-sub">Accede a tu panel de clínica</div>
                <div className="lp-form-group">
                  <div className="lp-label">Email</div>
                  <div className="lp-input-mock">tu@clinica.com</div>
                </div>
                <div className="lp-form-group">
                  <div className="lp-label">Contraseña</div>
                  <div className="lp-input-mock" style={{letterSpacing:3}}>••••••••</div>
                </div>
                <div className="lp-form-row">
                  <span className="lp-remember">☑ Recordarme</span>
                  <Link to="/login" className="lp-forgot">¿Olvidaste tu contraseña?</Link>
                </div>
                <Link to="/login" className="lp-btn lp-btn-accent lp-btn-block" style={{borderRadius:8}}>Entrar al panel →</Link>
                <div className="lp-form-divider">o continúa con</div>
                <Link to="/login" className="lp-btn lp-btn-ghost lp-btn-block" style={{borderRadius:8}}>
                  <svg width="16" height="16" viewBox="0 0 48 48" style={{display:'inline',verticalAlign:'middle',marginRight:6}}>
                    <path fill="#4285F4" d="M46.145 24.544c0-1.635-.15-3.207-.41-4.716H24v8.91h12.434c-.54 2.888-2.178 5.33-4.64 6.97v5.793h7.51c4.393-4.047 6.84-10.007 6.84-16.957z"/>
                    <path fill="#34A853" d="M24 47c6.237 0 11.467-2.07 15.29-5.6l-7.51-5.792c-2.07 1.39-4.718 2.208-7.78 2.208-5.984 0-11.053-4.042-12.863-9.48H3.39v5.99C7.197 42.15 15.01 47 24 47z"/>
                    <path fill="#FBBC05" d="M11.137 28.336A14.956 14.956 0 0 1 10.363 24c0-1.506.26-2.97.724-4.336V13.67H3.39A23.96 23.96 0 0 0 0 24c0 3.868.926 7.524 2.56 10.74l8.577-6.404z"/>
                    <path fill="#EA4335" d="M24 9.527c3.366 0 6.386 1.158 8.764 3.433l6.572-6.573C35.45 2.38 30.22 0 24 0 15.01 0 7.197 4.85 3.39 11.893l8.747 6.77C13.947 13.57 18.916 9.527 24 9.527z"/>
                  </svg>
                  Continuar con Google
                </Link>
                <div className="lp-signup">¿Aún no tienes cuenta? <Link to="/login">Regístrate gratis</Link></div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="lp-section lp-cta-bg">
          <div className="lp-container">
            <h2 className="lp-h2">Empieza hoy.<br /><em>14 días gratis</em>, sin compromisos.</h2>
            <p className="lp-cta-sub">Únete a más de 500 clínicas dentales que ya usan Plannitas para gestionar su día a día.</p>
            <div className="lp-cta-actions">
              <Link to="/login" className="lp-btn lp-btn-accent lp-btn-xl">Crear cuenta gratis</Link>
              <Link to="/login" className="lp-btn lp-btn-ghost-light lp-btn-xl">Ya tengo cuenta →</Link>
            </div>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="lp-footer">
          <div className="lp-footer-grid">
            <div>
              <a href="#" className="lp-footer-logo">Plann<span>itas</span></a>
              <p className="lp-footer-desc">Software de gestión para clínicas dentales modernas. Más organización, menos papeleos, mejores resultados.</p>
            </div>
            <div className="lp-footer-col">
              <h4>Producto</h4>
              <a href="#features">Funcionalidades</a>
              <a href="#preview">La App</a>
              <a href="#pricing">Precios</a>
              <a href="#changelog">Changelog</a>
            </div>
            <div className="lp-footer-col">
              <h4>Empresa</h4>
              <a href="#about">Sobre nosotros</a>
              <a href="#blog">Blog</a>
              <a href="#careers">Carreras</a>
              <a href="#contact">Contacto</a>
            </div>
            <div className="lp-footer-col">
              <h4>Legal</h4>
              <a href="#privacy">Privacidad</a>
              <a href="#terms">Términos de uso</a>
              <a href="#cookies">Cookies</a>
              <a href="#gdpr">RGPD</a>
            </div>
          </div>
          <div className="lp-footer-bottom">
            <span>© 2025 Plannitas · Todos los derechos reservados</span>
            <span>Hecho con ♥ para dentistas</span>
          </div>
        </footer>
      </div>
    </>
  );
};

export default Landing;
